import { isInsideFeedArea } from "../feedAreas";
import { feedsDevice } from "./feedsDevice";
import type { PickFeeder } from "./types";

export const pickFeeder: PickFeeder = ({
  category,
  typeName,
  point,
  feeds,
  positions,
  mainLabel,
  zones,
  reaches,
}) => {
  const feeders = Object.keys(feeds).filter(
    (label) =>
      positions[label] &&
      feedsDevice({ feed: feeds[label], category, typeName }) &&
      (!point || !reaches || reaches(label, point)),
  );
  if (!feeders.length) return null;
  // The latest zone wins where zones overlap, the same order zones are applied in.
  const zone = point
    ? [...zones]
        .reverse()
        .find((area) => feeders.includes(area.sourceLabel) && isInsideFeedArea({ point, area }))
    : undefined;
  if (zone) return { label: zone.sourceLabel, reason: "zone" };
  if (mainLabel && feeders.includes(mainLabel)) return { label: mainLabel, reason: "main" };
  if (feeders.length === 1) return { label: feeders[0], reason: "onlyFeeder" };
  if (!point) return { label: feeders[0], reason: "nearest" };
  const nearest = feeders.reduce((best, label) => {
    const at = positions[label];
    const bestAt = positions[best];
    const distance = (at.x - point.x) ** 2 + (at.y - point.y) ** 2;
    const bestDistance = (bestAt.x - point.x) ** 2 + (bestAt.y - point.y) ** 2;
    return distance < bestDistance ? label : best;
  });
  return { label: nearest, reason: "nearest" };
};
